<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-6 login-row form-wrap">
                <h1 class="text-center" v-html="boxTitle"></h1>
                <div class="alert alert-danger" role="alert" v-show="hasError">{{errorMessage}}</div>
                <div style="margin-bottom: 30px" asp-validation-summary="All"></div>

                <form @submit.prevent class="login-form">
                    <div class="input-wrap">
                        <label for="email">E-mail</label>
                        <input type="email" placeholder="Digite o seu e-mail" v-model="credentials.email" v-validate="modelValidations.email" :class="{'is-danger': errors.has('email')}" data-vv-name="email" required>
                        <i class="fa fa-envelope-o" aria-hidden="true"></i>
                        <div v-show="errors.has('email')" class="help">
                            {{ errors.first('email') }}
                        </div>
                    </div>

                    <div class="input-wrap" v-if="!isSendPassword">
                        <label for="password">Senha</label>
                        <input type="password" placeholder="Digite a sua senha" v-model="credentials.password" v-validate="modelValidations.password" :class="{'is-danger': errors.has('senha')}" data-vv-name="senha" required>
                        <i class="fa fa-key" aria-hidden="true"></i>
                        <div v-show="errors.has('senha')" class="help">
                            {{ errors.first('senha') }}
                        </div>
                    </div>

                    <div class="row" v-show="!isResetPassword">
                        <div class="col-sm-6 d-flex d-sm-block justify-content-center">
                            <!-- <div class="checkbox">
                                <input type="checkbox">
                                <label for="remember">Lembrar de mim</label>
                            </div> -->
                            <!-- /.checkbox -->
                        </div>
                        <!-- /.col-sm-6 -->

                        <div class="col-sm-6 forgot">
                            <a href="javascript:void(0)" @click="sendPassword">{{isSendPassword ? 'Cancelar' : 'Esqueceu sua senha?'}}</a>
                        </div>
                        <!-- /.col-sm-6 -->
                    </div>
                    <!-- /.row -->
                    <button type="submit" @click.prevent="validate" :disabled="loading">
                        <template v-if="loading">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Aguarde...
                        </template>
                        <template v-else>
                            {{boxTitle}}
                        </template>
                    </button>                    
                </form>               
            </div>
        </div>
        <!-- /.row -->
    </div>
    <!-- /.container -->
</template>
<script>
import accountService from '../../services/Account/accountService'
export default {
    props: {
        rt: String
    },
    data() {
        return {
            shown: false,
            hasError: false,
            errorMessage: '',
            loading: false,
            credentials: {
                email: '',
                password: ''
            },
            modelValidations: {
                email: {
                required: true,
                email: true
                },
                password: {
                required: true,
                min: 8
                }
            },
            isSendPassword: false
        }
    },
    computed: {
        isResetPassword() {
            return this.rt ? true : false
        },
        boxTitle() {
            if(this.isResetPassword)
                return 'Alterar Senha'
            if(this.isSendPassword)
                return 'Enviar Senha'            
            return 'Entrar'
        }
    },
    beforeMount() {
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            this.installEvent = e;
            this.shown = true;
        });
    },
    methods: {        
        validate() {
            this.loading = true
            const self = this
            this.hasError = false
            this.errorMessage = ''
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    if(self.isResetPassword) {
                        accountService.resetPassword(self.$data.credentials.email, self.$data.credentials.password, self.rt)
                        .then(
                            r => {
                                self.handleSuccessful(self, r)
                            },
                            err => {
                                self.handleError(self, err)
                            }
                        )
                    }
                    else if(self.isSendPassword)
                    {
                        accountService.sendToken(self.$data.credentials.email)
                        .then(
                            r => {
                                self.disableSendPassword()
                                self.errorMessage = 'E-mail com informações para nova senha enviada com sucesso!'
                                self.hasError = true
                                self.loading = false
                            },
                            
                            err => {
                                self.handleError(self, err)
                            }
                        )
                    }
                    else
                    {
                        accountService.signin(self.$data.credentials.email, self.$data.credentials.password)
                        .then(
                            r => {
                                self.handleSuccessful(self, r)
                            },
                            err => {
                                self.handleError(self, err)
                            }
                        )
                    }
                    
                } 
                else 
                {
                    self.loading = false
                }
            })
        },
        handleSuccessful(vw, r) {
            const response = r.data
            if (response && response.user) {
                vw.$store.dispatch('setUser', response)
                window.location = '/'
                return
            }
            vw.errorMessage = response.message
            vw.hasError = true
            vw.loading = false
        },
        handleError(vw, err) {
            const msg = err.response.status == 404 ? err.message : err.response.data.message
            vw.errorMessage = msg
            vw.hasError = true
            vw.loading = false
        },
        sendPassword() {
            this.isSendPassword = !this.isSendPassword
        },
        disableSendPassword() {
            this.isSendPassword = false
        }
    }
}
</script>
<style scoped>

</style>
